import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  DsChipComponent,
  IconComponent,
  ItemComponent,
  ItemLeadingComponent,
  ItemTitleComponent,
  ItemTrailingComponent,
  SwitchComponent,
  TranslatePipe
} from '@softline/ui-core';
import { PageFilterItem } from '../../../../types/page-filter-item';
import { Filter } from '../../../../../types/filter';
import { FilterOperatorComponent } from '../../../../../components/filter-operator/filter-operator.component';

@Component({
  selector: 'soft-page-filter-list-item',
  imports: [
    DsChipComponent,
    IconComponent,
    ItemComponent,
    ItemLeadingComponent,
    ItemTitleComponent,
    ItemTrailingComponent,
    FilterOperatorComponent,
    SwitchComponent,
    TranslatePipe
  ],
  templateUrl: './page-filter-list-item.component.html',
  styleUrl: './page-filter-list-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFilterListItemComponent<T extends object> {
  item = input.required<PageFilterItem<T, any>>();
  value = input<Filter<any> | null>();
  /** exact-match active state of a toggle item (computed by the parent against the draft) */
  toggleActive = input<boolean>(false);

  clearFilter = output<PageFilterItem<T, any>>();
  activate = output<PageFilterItem<T, any>>();

  // toggle items flip their fixed value in place (via row activate) instead of opening the detail
  readonly isToggle = computed(() => !!this.item().toggle);
}
